import React, { FC } from 'react';
import {
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';
import { SupportedLanguage } from '@demind-inc/core';
import { useTranslation } from 'react-i18next';

import { useLanguageContext } from '../../../../../data-access';
import { SETTING_ICONS } from '../../../constants';
import './LanguageSection.scss';

const LanguageSection: FC = () => {
  const Icon = SETTING_ICONS.general;
  const { t } = useTranslation();
  const { language, languageOptions, changeLanguage, isLanguageLoading, isLanguageSaving } =
    useLanguageContext();

  const handleLanguageChange = (event: SelectChangeEvent<SupportedLanguage>) => {
    changeLanguage(event.target.value as SupportedLanguage);
  };

  return (
    <div className="language-section language-section--new-tabs">
      <div className="language-section__block">
        <Stack gap={1} direction="row" alignItems="center">
          <Icon className="language-section__section-icon" />
          <Typography variant="body1" className="language-section__section-title">
            {t('settings.general.language')}
          </Typography>
        </Stack>

        <div className="language-section__control">
          {isLanguageLoading || isLanguageSaving ? (
            <div className="language-section__loader">
              <CircularProgress size={16} />
            </div>
          ) : (
            <FormControl size="small" className="language-section__select-control">
              <Select<SupportedLanguage>
                value={language}
                onChange={handleLanguageChange}
                className="language-section__select"
                aria-label={t('settings.general.language')}
                MenuProps={{ PaperProps: { className: 'language-section__menu' } }}
              >
                {languageOptions.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    className="language-section__menu-item"
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </div>
      </div>
    </div>
  );
};

export default LanguageSection;
